var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocalDining = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41228 10.5609L8.6527 8.32044L3.0952 2.77086C1.8602 4.00586 1.8602 6.00878 3.0952 7.25169L6.41228 10.5609ZM11.7798 9.12794C12.991 9.69003 14.6931 9.29419 15.9519 8.03544C17.4639 6.52336 17.7569 4.35419 16.5931 3.19044C15.4373 2.03461 13.2681 2.31961 11.7481 3.83169C10.4894 5.09044 10.0935 6.79253 10.6556 8.00378L2.92895 15.7304L4.0452 16.8467L9.49978 11.4079L14.9464 16.8546L16.0627 15.7384L10.616 10.2917L11.7798 9.12794Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocalDining, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/local_dining.dd4351a1.svg";
export { ForwardRef as ReactComponent };